module.exports = __webpack_public_path__ + "media/images/application/template/logo-leviat-no-crh-cropped-ba30c309b1b631bf300ac8208fb99206.svg";